import { render, staticRenderFns } from "./revisePassword.vue?vue&type=template&id=28673e7a&scoped=true"
import script from "./revisePassword.vue?vue&type=script&lang=js"
export * from "./revisePassword.vue?vue&type=script&lang=js"
import style0 from "./revisePassword.vue?vue&type=style&index=0&id=28673e7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28673e7a",
  null
  
)

export default component.exports